import script from "./ParentDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ParentDashboard.vue?vue&type=style&index=0&id=76bd7b03&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76bd7b03"]])

export default __exports__